var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverlayHeaderKakaoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_\xEC\xB9\xB4\xEC\xB9\xB4\xEC\x98\xA4\xED\x86\xA1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.3333 3.5C6.28264 3.5 3 6.06302 3 9.22328C3 11.2319 4.32836 12.9982 6.33458 14.0199L5.64442 16.832L8.95167 14.8421C9.40891 14.9106 9.87078 14.9451 10.3333 14.9452C14.384 14.9452 17.6667 12.3822 17.6667 9.22194C17.6667 6.06168 14.384 3.5 10.3333 3.5Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverlayHeaderKakaoBlack);
export default __webpack_public_path__ + "static/media/overlay_header_kakao_black.9f6a91fb0820c5be51de12e1923b65f5.svg";
export { ForwardRef as ReactComponent };